module.exports = __webpack_public_path__ + "img/icon-office.87b0bb72.svg";